let ringtone = null;
let playing = false;

function getRingtone() {
  if (!ringtone) {
    ringtone = new Audio("/sounds/call.ogg");
    ringtone.preload = "auto";
  }

  return ringtone;
}

export function startCallRingtone() {
  const audio = getRingtone();

  if (playing && !audio.paused) return;

  playing = true;
  audio.loop = true;
  audio.currentTime = 0;

  audio.play().catch((error) => {
    playing = false;
    console.log('callRingtone.play() [error:"%o]', error);
  });
}

export function stopCallRingtone() {
  playing = false;

  if (!ringtone) return;

  ringtone.loop = false;
  ringtone.pause();
  ringtone.currentTime = 0;
}
